export interface PurchaseInvoiceQualitySummaryReport {
  productGroup: string;
  commodityCode: string;
  quantity: number;
  grossKgs: number;
  nettKgs: number;
}
